import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterBar from './components/FilterBar';
import KpiCards from './components/KpiCards';
import UsageTable from './components/UsageTable';
import UsageChart from './components/UsageChart';
import { useLlmUsageSummary, useLlmUsageTimeSeries } from '@/data/llmUsage';
import { Error } from '@/components/ui/error';
import { Loading } from '@/components/ui/loading';

const getDefaultStartDate = () => {
  const d = new Date();
  d.setDate(d.getDate() - 30);
  return d.toISOString().split('T')[0];
};

const getDefaultEndDate = () => {
  return new Date().toISOString().split('T')[0];
};

const Page = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const startDate = searchParams.get('startDate') || getDefaultStartDate();
  const endDate = searchParams.get('endDate') || getDefaultEndDate();

  const updateParam = useCallback(
    (key, value) => {
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        if (value === null || value === undefined || value === '') {
          next.delete(key);
        } else {
          next.set(key, value);
        }
        return next;
      });
    },
    [setSearchParams]
  );

  const handleReset = useCallback(() => {
    setSearchParams({});
  }, [setSearchParams]);

  const filters = { startDate, endDate };
  const summary = useLlmUsageSummary(filters);
  const timeSeries = useLlmUsageTimeSeries(filters);

  if ((summary.isLoading && !summary.data) || (timeSeries.isLoading && !timeSeries.data)) {
    return <Loading />;
  }

  if (summary.error) {
    return <Error message="An error occurred loading LLM usage summary" />;
  }

  if (timeSeries.error) {
    return <Error message="An error occurred loading LLM usage time series" />;
  }

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-lg font-semibold">LLM Usage</h1>
        <p className="text-sm text-muted-foreground">Token consumption and cost per company</p>
      </div>

      <FilterBar startDate={startDate} endDate={endDate} onStartDateChange={(v) => updateParam('startDate', v)} onEndDateChange={(v) => updateParam('endDate', v)} onReset={handleReset} />

      <KpiCards summary={summary.data} />

      <UsageChart timeSeries={timeSeries.data} />

      <UsageTable summary={summary.data} />
    </div>
  );
};

export default Page;
